import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = ["onClick"];
import TUIChatEngine, { TUIStore, StoreName, TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import TUICore, { TUIConstants } from "@tencentcloud/tui-core";
import { ref } from "../../../adapter-vue";
import Icon from "../../common/Icon.vue";
import backSVG from "../../../assets/icon/back.svg";
import { isPC } from "../../../utils/env";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["closeChat"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emits = __emit;
    var _currentConversation = ref();
    var currentConversationName = ref("");
    var _typingStatus = ref(false);
    var groupID = ref("");
    var extensions = ref([]);
    TUIStore.watch(StoreName.CONV, {
      currentConversation: function currentConversation(conversation) {
        var _currentConversation$, _currentConversation$2, _currentConversation$3;
        var isGroup = (conversation === null || conversation === void 0 ? void 0 : conversation.type) === TUIChatEngine.TYPES.CONV_GROUP;
        if (isGroup && ((_currentConversation$ = _currentConversation.value) === null || _currentConversation$ === void 0 ? void 0 : _currentConversation$.conversationID) !== (conversation === null || conversation === void 0 ? void 0 : conversation.conversationID)) {
          extensions.value = TUICore.getExtensionList(TUIConstants.TUIChat.EXTENSION.CHAT_HEADER.EXT_ID, {
            filterManageGroup: !isGroup
          });
        }
        if (!isGroup) {
          extensions.value = [];
        }
        _currentConversation.value = conversation;
        groupID.value = (_currentConversation$2 = _currentConversation.value) === null || _currentConversation$2 === void 0 || (_currentConversation$2 = _currentConversation$2.groupProfile) === null || _currentConversation$2 === void 0 ? void 0 : _currentConversation$2.groupID;
        currentConversationName.value = _currentConversation === null || _currentConversation === void 0 || (_currentConversation$3 = _currentConversation.value) === null || _currentConversation$3 === void 0 ? void 0 : _currentConversation$3.getShowName();
      }
    });
    TUIStore.watch(StoreName.CHAT, {
      typingStatus: function typingStatus(status) {
        var _currentConversation$4;
        _typingStatus.value = status;
        switch (_typingStatus.value) {
          case true:
            currentConversationName.value = TUITranslateService.t("TUIChat.对方正在输入");
            break;
          case false:
            currentConversationName.value = _currentConversation === null || _currentConversation === void 0 || (_currentConversation$4 = _currentConversation.value) === null || _currentConversation$4 === void 0 ? void 0 : _currentConversation$4.getShowName();
            break;
        }
      }
    });
    var closeChat = function closeChat(conversationID) {
      emits("closeChat", conversationID);
    };
    var handleExtensions = function handleExtensions(item) {
      item.listener.onClicked({
        groupID: groupID.value
      });
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass(['chat-header', !_unref(isPC) && 'chat-header-h5'])
      }, [_withDirectives(_createElementVNode("div", {
        "class": _normalizeClass(['chat-header-back', !_unref(isPC) && 'chat-header-h5-back']),
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return closeChat(_unref(_currentConversation).conversationID);
        })
      }, [_createVNode(Icon, {
        file: _unref(backSVG)
      }, null, 8, ["file"])], 2), [[_vShow, !_unref(isPC)]]), _createElementVNode("div", {
        "class": _normalizeClass(['chat-header-content', !_unref(isPC) && 'chat-header-h5-content'])
      }, _toDisplayString(_unref(currentConversationName)), 3), _createElementVNode("div", {
        "class": _normalizeClass(['chat-header-setting', !_unref(isPC) && 'chat-header-h5-setting'])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(extensions), function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          onClick: _withModifiers(function ($event) {
            return handleExtensions(item);
          }, ["stop"])
        }, [_createVNode(Icon, {
          file: item.icon
        }, null, 8, ["file"])], 8, _hoisted_1);
      }), 128))], 2)], 2);
    };
  }
});